function tasks(
  state = { items: [], selectedId: -1, selectedFrame: 0, nextLesson: '' },
  action
) {
  switch (action.type) {
    case 'RECEIVE_TASKS':
      return {
        ...state,
        items: action.tasks,
      };
    case 'RECEIVE_NEXT_LESSON':
      return {
        ...state,
        nextLesson: action.nextLessonId,
      };
    case 'SELECT_TASK':
      return {
        ...state,
        selectedId: action.id,
        selectedFrame:
          action.frame !== undefined ? action.frame : state.selectedFrame,
      };
    case 'SELECT_FRAME':
      return {
        ...state,
        selectedFrame: action.frame,
      };
    default:
      return state;
  }
}

export default tasks;
